<!-- @format -->

<template>
  <div>
    <div class="ui">
      <div class="ui attached message">
        <div class="content">
          <div class="header">Goal Details</div>
        </div>
      </div>
      <div class="ui attached segment">
        <div class="ui field">
          <strong>Wrapper</strong>
          <v-select
            label="text"
            :reduce="(z) => z.value"
            @input="handleChange"
            v-model="wrapperType"
            :options="wrapperTypes"
          >
            <template v-slot:option="option">{{ option.text }}</template>
          </v-select>
        </div>
        <br />
        <div class="ui form fluid">
          <div class="ui field">
            <label>Goal Name</label>
            <input @change="handleChange" v-model="goalName" />
          </div>
          <div class="ui field"></div>
          <div class="ui field">
            <label>Goal Description</label>
            <textarea
              @change="handleChange"
              v-model="goalDescription"
              rows="2"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="ui divider"></div>
      <div class="ui attached message">
        <div class="content">
          <div class="header">Goal Targets</div>
          <br />
          <div>
            <div class="ui checkbox">
              <input
                type="checkbox"
                v-on:change="handleChange"
                v-model="goalHasTarget"
                name="example"
              />
              <label>Does Goal have a Target?</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="goalHasTarget" class="ui attached segment">
        <div class="ui form fluid">
          <div class="ui form">
            <div class="ui field">
              <label>
                Goal Target Age
                <small v-if="goalTargetAge > currentAge"
                  >( {{ goalTargetAge - currentAge }} years from now )</small
                >
              </label>
              <input @change="handleChange" v-model.number="goalTargetAge" />
              <span style="color: red" v-if="goalTargetAge < currentAge">
                <small>
                  Must be greater or equal to current age
                  {{ currentAge }}
                </small>
              </span>
            </div>
          </div>
          <div class="ui field">
            <label>
              Target Amount
              <small v-if="goalTargetAge - currentAge > 0">
                ( {{ shortCurrency
                }}{{
                  formatNr(discounted(goalTarget, goalTargetAge - currentAge))
                }}
                in today's terms )
              </small>
            </label>
            <currency-input
              @change="handleChange"
              v-model.number="goalTarget"
              :currency="currency"
            />
          </div>
        </div>
      </div>
      <div v-if="!goalHasTarget" class="ui attached segment">No target</div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";

export default {
  name: "GoalInput",
  components: { vSelect },
  props: [
    "currency",
    "shortCurrency",
    "goalName",
    "goalDescription",
    "goalHasTarget",
    "goalTarget",
    "goalTargetAge",
    "currentAge",
    "aaType",
  ],
  data() {
    return {
      wrapperTypes: [
        { text: "Retirement Annuity", value: "RetirementAnnuity" },
        { text: "Living Annuity", value: "LivingAnnuity" },
        { text: "TFSA", value: "TFSA" },
        { text: "Discretionary", value: "Discretionary" },
      ],
    };
  },
  computed: {
    expectedInflationRate() {
      if (this.aaType == "Simple" && this.currency == "ZAR") return 0.055;
      if (this.aaType == "Extended" && this.currency == "ZAR") return 0.05;
      if (this.currency == "USD") return 0.025;

      return 0.055;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else {
        return numeral(val).format("0,0.0a");
      }
    },
    discounted(val, years) {
      return val / Math.pow(1 + this.expectedInflationRate, years); // finlation adjusted
    },
    handleChange() {
      // construct withdrawal weights
      //let weights = [];

      this.$emit("handleSelected", {
        goalName: this.goalName,
        goalDescription: this.goalDescription,
        goalHasTarget: this.goalHasTarget,
        goalTarget: this.goalTarget,
        goalTargetAge: this.goalTargetAge,
        wrapperType: this.wrapperType,
      });
    },
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
